import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useMemo, useState } from "react";

import { Checkbox } from "@material-ui/core";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import Changes from "../../common/Changes";
import CloneProfileLimit from "../../common/CloneProfileLimit";
import InputSelect from "../../common/InputSelect";

export default function WagerLimitInfo(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    label: {
      fontSize: 12,
      margin: 0,
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: "100%",
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
    centerFS: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const { values: wagerLimits } = useDataFormatterHook({
    value: "idProfileLimits",
    text: "profileName",
    path: `/Player/GetPlayerProfileLimits?idUser=${userInfo.userId}`,
  });

  const handleUpdate = (event, key, value) => {
    props.WagerLimit[key] = event ? event.target.value : value;
    props.UpdateWagerLimit(props.WagerLimit);
  };

  const [localWagerLimit, setLocalWagerLimit] = useState(props.WagerLimit);
  const handleChange = (event, key, value) => {
    setLocalWagerLimit({
      ...localWagerLimit,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalWagerLimit(props.WagerLimit);
  }, [props.WagerLimit, setLocalWagerLimit]);

  return (
    <React.Fragment>
      <h2 className="w-full text-center">{localWagerLimit.profileName}</h2>
      <form className={`${classes.center} grid grid-cols-3 w-full gap-4`}>
        <div className="vertical-options">
          <TextField
            className="w-full"
            size="small"
            type="text"
            label="Name"
            value={localWagerLimit.profileName}
            multiline={false}
            onChange={(event) => handleChange(event, "profileName")}
            onBlur={(event) => handleUpdate(event, "profileName")}
            variant="outlined"
          />
          <div className="flex flex-row gap-4">
            <Checkbox
              className="w-auto"
              size="small"
              checked={localWagerLimit.alternateEnable}
              onChange={(event) => {
                handleChange(
                  undefined,
                  "alternateEnable",
                  event.target.checked
                );
                handleUpdate(
                  undefined,
                  "alternateEnable",
                  event.target.checked
                );
              }}
              color="primary"
            />
            <InputSelect
              variant="outlined"
              size="small"
              label="Alternate"
              name="name"
              data={wagerLimits}
              placeholder="DataFormatter"
              setSelectValue={(value) =>
                handleChange(undefined, "alternateProfile", value)
              }
              startValue={localWagerLimit.alternateProfile}
            />
          </div>
        </div>
        <div className="vertical-options">
          <TextField
            className="flex-1"
            size="small"
            type="text"
            label="Notes"
            value={localWagerLimit.notes}
            onChange={(event) => handleChange(event, "notes")}
            onBlur={(event) => handleUpdate(event, "notes")}
            variant="outlined"
            multiline
            minRows={4}
          />
        </div>
        <div className="flex flex-col">
          <Changes
            title={`Profile Changes`}
            buttonText={"Profile Changes"}
            params={{
              ChangeType: 23,
              IdSport: "",
              Param1: props.WagerLimit.idProfileLimits,
              Param2: -1,
              Param3: -1,
            }}
          />
          <br></br>
          <CloneProfileLimit
            title={`Clone Profile Limit`}
            buttonText={"Clone"}
            params={{
              Id: props.WagerLimit.idProfileLimits,
            }}
          />
        </div>
      </form>
    </React.Fragment>
  );
}
